import { createFileRoute } from "@tanstack/react-router";

import { LabelsPage } from "src/pages/LabelsPage";

export const Route = createFileRoute("/_auth/_coach/orgs/$slug/labels/")({
  component: LabelsPage,
  ssr: true,
  staticData: {
    getBreadcrumb({ params }) {
      return {
        id: "labels",
        labelTranslationKey: "labelsPage.title",
        href: `/orgs/${params.slug}/labels`,
      };
    },
  },
});
